import React from 'react'
import { EnterpriseDetail } from '../../../clients/kyousou_api_client'
import InfoIcon from '../../../images/info_icon.png'
import {
  QuillDisplay,
} from '../../../components/form/inputs/QuillEditor'

interface SdgsTabProps {
  enterprise: EnterpriseDetail
}

const SdgsTab: React.FC<SdgsTabProps> = ({
  enterprise,
}) => {
  const sdgsInitiatives = enterprise.sdgsInitiatives

  if (!sdgsInitiatives) {
    return (
      <div className="text-center text-main-darkgray py-8">
        SDGsの取り組みは登録されていません。
      </div>
    )
  }

  return (
    <div>
      <h3 className="text-xl font-bold text-main-black mb-4">
        SDGsへの取り組み
      </h3>
      {sdgsInitiatives.sdgsCategories &&
        sdgsInitiatives.sdgsCategories.length > 0 && (
          <div className="space-y-3 mb-8">
            {sdgsInitiatives.sdgsCategories
              // 数字が小さい順にソート
              .sort((a, b) => Number(a.code) - Number(b.code))
              .map((category) => (
                <div
                  key={category.code}
                  className="bg-main-green text-white px-3 py-0.5 rounded-2xl w-fit"
                >
                  目標 {category.code}: {category.value}
                </div>
              ))}
          </div>
        )}

      {/* 再生可能エネルギーの普及 */}
      {sdgsInitiatives?.renewableEnergy && (
        <div className="pb-6">
          <h4 className="text-xl font-bold text-main-black mb-3">
            再生可能エネルギーの普及
          </h4>
          <QuillDisplay content={sdgsInitiatives.renewableEnergy || ''} />
        </div>
      )}

      {/* 区切り線 */}
      {sdgsInitiatives?.renewableEnergy &&
        (sdgsInitiatives?.energyEfficiency ||
          sdgsInitiatives?.environmentalEducation) && (
          <div className="border-b border-black mb-6"></div>
        )}

      {/* エネルギー効率化技術の開発 */}
      {sdgsInitiatives?.energyEfficiency && (
        <div className="pb-6">
          <h4 className="text-xl font-bold text-main-black mb-3">
            エネルギー効率化技術の開発
          </h4>
          <QuillDisplay content={sdgsInitiatives.energyEfficiency || ''} />
        </div>
      )}

      {/* 区切り線 */}
      {sdgsInitiatives?.energyEfficiency &&
        sdgsInitiatives?.environmentalEducation && (
          <div className="border-b border-black mb-6"></div>
        )}

      {/* 環境教育プログラムの実施 */}
      {sdgsInitiatives?.environmentalEducation && (
        <div className="pb-6">
          <h4 className="text-xl font-bold text-main-black mb-3">
            環境教育プログラムの実施
          </h4>
          <QuillDisplay
            content={sdgsInitiatives.environmentalEducation || ''}
          />
        </div>
      )}

      {/* 区切り線 */}
      {sdgsInitiatives?.environmentalEducation &&
        sdgsInitiatives?.sdgsInfo && (
          <div className="border-b border-black mb-6"></div>
        )}
      
      {sdgsInitiatives?.sdgsInfo && (
        <div className="border-l-4 border-main-green bg-main-lightgreen p-2 mt-2">
          <div className="flex items-center">
            <img src={InfoIcon} alt="Info" className="w-6 h-6 mr-6" />
            <QuillDisplay content={sdgsInitiatives.sdgsInfo || ''} />
          </div>
        </div>
      )}
    </div>
  )
}

export default SdgsTab